/* External */
import {
  memo,
  createContext,
  useCallback,
  useContext,
  useEffect,
  useState,
  useRef,
} from 'react';
import PropTypes from 'prop-types';

/* Utils */
import platform from '../../utils/platform';

const KeyBoardStateContext = createContext(false);
const SetKeyBoardStateContext = createContext(() => {});

export function useKeyBoardState() {
  return useContext(KeyBoardStateContext);
}

export function useSetKeyBoardState() {
  return useContext(SetKeyBoardStateContext);
}

function KeyBoardStateProvider({ children }) {
  const [isKeyBoardVisible, setIsKeyBoardVisible] = useState(false);
  const isKeyBoardVisibleRef = useRef(isKeyBoardVisible);

  const handleKeyBoardStateChange = useCallback((visibility) => {
    setIsKeyBoardVisible(visibility);
  }, []);

  const handleWheel = useCallback((event) => {
    if (isKeyBoardVisibleRef.current && event.deltaY > 0 && document.activeElement) {
      document.activeElement.blur();
      event.preventDefault();
    }
  }, []);

  useEffect(
    () => platform.addKeyboardStateChangeListener(handleKeyBoardStateChange),
    [handleKeyBoardStateChange],
  );

  useEffect(() => {
    isKeyBoardVisibleRef.current = isKeyBoardVisible;
  }, [isKeyBoardVisible]);

  useEffect(() => {
    document.body.addEventListener('wheel', handleWheel);
    return () => {
      document.body.removeEventListener('wheel', handleWheel);
    };
  }, [handleWheel]);

  return (
    <KeyBoardStateContext.Provider value={isKeyBoardVisible}>
      <SetKeyBoardStateContext.Provider value={setIsKeyBoardVisible}>
        {children}
      </SetKeyBoardStateContext.Provider>
    </KeyBoardStateContext.Provider>
  );
}

KeyBoardStateProvider.propTypes = {
  children: PropTypes.node,
};

export default memo(KeyBoardStateProvider);
